import Alert from "./alert";
import AlternateGameDetails from "./alternate-game-details";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function AlternateGameAlert({ tokenTypes, tournament }) {
  if (!tournament.get("alternate_active")) {
    return null;
  }

  return (
    <div>
      <Alert icon="dw-warning7" subtle>
        <p>
          This game has an alternate game:
          {" "}

          {tournament.get("alternate_name")}
          .
        </p>
      </Alert>

      <AlternateGameDetails tokenTypes={tokenTypes} tournament={tournament} />
    </div>
  );
});
